import Id from './Id';
import Created from './Created';
import Updated from './Updated';
import CancelledRepresentativeSale from './CancelledRepresentativeSale';
import Currency from './Currency';
import Customer from './Customer';
import CustomerAddress from './CustomerAddress';
import GrossPrice from './GrossPrice';
import NetPrice from './NetPrice';
import ReceiptNumber from './ReceiptNumber';
import Shop from './Shop';
import Status from './Status';
import Storage from './Storage';
import Supplier from './Supplier';
import RepresentativeUser from './RepresentativeUser';
import PaymentMethod from './PaymentMethod';
import NavStatus from './NavStatus';

export const labels = {
  Id: 'Id',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  Currency: 'Deviza',
  CancelledRepresentativeSale: 'Kapcsoldódó sztornózott eladás',
  Customer: 'Vevő',
  NavStatus: 'Nav státusz',
  CustomerAddress: 'Vevő címe',
  GrossPrice: 'Bruttó ár',
  NetPrice: 'Nettó ár',
  ReceiptNumber: 'Bizonylat szám',
  Shop: 'Üzlet',
  Status: 'Státusz',
  Storage: 'Raktár',
  Supplier: 'Szállító',
  RepresentativeUser: 'Képviselő',
  PaymentMethod: 'Fizetési mód'
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'NavStatus',
}, {
  value: 'CancelledRepresentativeSale',
}, {
  value: 'Currency',
}, {
  value: 'Customer',
}, {
  value: 'CustomerAddress',
}, {
  value: 'GrossPrice',
}, {
  value: 'NetPrice',
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Shop',
}, {
  value: 'Status',
}, {
  value: 'Storage',
}, {
  value: 'Supplier',
}, {
  value: 'RepresentativeUser',
}, {
  value: 'PaymentMethod',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'RepresentativeUser',
}, {
  value: 'Customer',
}, {
  value: 'Shop',
}, {
  value: 'PaymentMethod',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'NavStatus',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'descending'
};

export default {
  Id,
  Created,
  Updated,
  CancelledRepresentativeSale,
  Currency,
  Customer,
  CustomerAddress,
  GrossPrice,
  NetPrice,
  ReceiptNumber,
  Shop,
  Status,
  Storage,
  Supplier,
  RepresentativeUser,
  PaymentMethod,
  NavStatus,
};
